import { en } from "./en";

const confirmDeleteWord = "SUPPRIMER";

export const fr = {
  sites: "Sites",
  settings: "Préférences",
  save: "Sauvegarder",
  add: "Ajouter",
  delete: "Supprimer",
  cancel: "Annuler",
  back: "Retour",
  dashboard: "Tableau de bord",
  "create a new site": "Créer un nouveau site",
  name: "Nom",
  edit: "Modifier",
  new: "Créer",
  "Sign Out": "Se déconnecter",
  signIn: "Se connecter",
  signUp: "S'inscrire",
  designer: "Éditeur",
  language: "Langue",
  color: "Couleur",
  "is already taken": "est déjà pris",
  "is available": "est disponible",
  "Your settings have been updated": "Vos paramètres ont été mis à jour",
  "Your email": "Votre adresse e-mail",
  "Forgotten password?": "Mot de passe oublié ?",
  "Don't have an account yet?": "Pas encore de compte ?",
  "Already have an account?": "Vous avez déjà un compte ?",
  title: "Titre",
  description: "Description",
  button: "Bouton",
  logo: "Logo",
  introduction: "Introduction",
  "Main button": "Bouton principal",
  "External link button": "Bouton vers un site externe",
  "Add an optional button that opens another website in a new tab.":
    "Ajoutez un bouton facultatif qui ouvre un autre site dans un nouvel onglet.",
  "Show external link button": "Afficher le bouton vers un site externe",
  "Button text": "Texte du bouton",
  "External URL": "URL externe",
  link: "Lien",
  "Site updated": "Site mis à jour",
  "Contact us": "Contactez-nous",
  "Still have questions? Get in touch.": "Une question ? Écrivez-nous.",
  "Our services": "Nos services",
  username: "Nom d'utilisateur",
  password: "Mot de passe",
  contactForm: "Formulaire de contact",
  dangerZone: "Zone à risque",
  "Book Appointment": "Prendre rendez-vous en ligne",
  seoDescriptionMessage: `Les mots-clés décrivent votre contenu et aident les moteurs de recherche à le classer. Cependant, parce que trop de gens en abusent, les moteurs de recherche donnent désormais la priorité à la façon dont votre contenu répond aux questions des utilisateurs. Utilisez les mots-clés de manière naturelle, mais ne les forcez pas. Concentrez-vous plutôt sur la création d'un contenu clair, pertinent et détaillé.`,
  Keyword: "Mot-clé",
  "This action cannot be reverted or undone": [
    "Cette action ne peut pas être annulée ou rétablie.",
    "Une fois supprimées, toutes les données",
    "seront définitivement supprimées et ne pourront pas être récupérées",
  ].join(" "),
  "Are you sure?": "Êtes-vous sûr ?",
  "delete your account": "Supprimer votre compte",
  confirmDeleteWord,
  "Are you sure you want to delete this site? To confirm, type DELETE.": [
    `Êtes-vous sûr de vouloir supprimer ce site ?`,
    `Pour confirmer, tapez '${confirmDeleteWord}'.`,
    `Cette action ne peut pas être annulée.`,
  ].join(" "),
  "Are you sure you want to delete your account? To confirm, type DELETE.": [
    `Êtes-vous sûr de vouloir supprimer votre compte ?`,
    `Pour confirmer, tapez '${confirmDeleteWord}'.`,
    `Cette action ne peut pas être annulée.`,
  ].join(" "),
  "Your account has been deleted": "Votre compte a été supprimé.",
  "Something went wrong": "Désolé, une erreur est survenue !",
  general: "Général",
  domains: "Domaines",
  "Domain deleted": "Domaine supprimé",
  seo: "Référencement",
  ai: "IA",
  billings: "Facturation",
  "Keywords describe your content and help search engines categorize it": [
    `Les mots-clés décrivent votre contenu et aident les moteurs de recherche à le catégoriser.`,
    `Cependant, parce que trop de gens en abusent,`,
    `les moteurs de recherche donnent maintenant la priorité à la façon dont votre contenu répond aux questions des utilisateurs.`,
    `Utilisez les mots-clés de manière naturelle, mais ne les forcez pas.`,
    `Au lieu de cela, concentrez-vous sur la création d'un contenu clair, pertinent et détaillé.`,
  ].join(" "),
  "A domain is the unique web address (e.g. yourwebsite.com) that people use to access your site.":
    "Un domaine est l'adresse web unique (par exemple, votresiteweb.com) que les gens utilisent pour accéder à votre site.",
  "Add both DNS records at your DNS provider. Choose CNAME as the record type.":
    "Ajoutez les deux enregistrements DNS auprès de votre fournisseur DNS. Choisissez CNAME comme type d’enregistrement.",
  "Domain setup": "Configuration du domaine",
  "DNS records": "Enregistrements DNS",
  "DNS provider": "Fournisseur DNS",
  "Setup guide": "Guide de configuration",
  "If you encounter any difficulties, please contact us":
    "Si vous rencontrez des difficultés, contactez-nous",
  "CNAME doc links - OVH":
    "https://docs.ovhcloud.com/fr/guides/web-cloud/domains/dns-zone-cname-record-creation",
  "CNAME doc links - Ionos":
    "https://www.ionos.fr/assistance/domaines/configurer-des-enregistrements-cname-pour-des-sous-domaines/configurer-un-enregistrement-cname-pour-un-sous-domaine-existant/",
  "CNAME doc links - Cloudflare":
    "https://developers.cloudflare.com/dns/manage-dns-records/how-to/create-dns-records/",
  "CNAME doc links - GoDaddy":
    "https://www.godaddy.com/help/add-a-cname-record-19236",
  "CNAME doc links - Namecheap":
    "https://www.namecheap.com/support/knowledgebase/article.aspx/9646/2237/how-to-create-a-cname-record-for-your-domain/",
  "CNAME doc links - Squarespace":
    "https://support.squarespace.com/hc/fr-fr/articles/360002101888-Modifier-les-enregistrements-DNS-de-votre-domaine",
  Team: "Équipe",
  "About Us": "À propos",
  Photo: "Photo",
  Text: "Texte",
  FAQ: "FAQ",
  Question: "Question",
  Answer: "Réponse",
  "Frequently asked questions": "Questions fréquentes",
  "Type your text here...": "Saisissez votre texte ici...",
  "Social links": "Liens sociaux",
  "Add social link": "Ajouter un lien social",
  designerHeroTitlePlaceholder: "Studio Acme",
  designerHeroDescriptionPlaceholder:
    "Nous aidons les entreprises locales à donner vie à leurs idées.",
  designerButtonLabelPlaceholder: "Réserver un appel",
  designerButtonUrlPlaceholder: "https://cal.com/votre-entreprise",
  designerServicesTitlePlaceholder: "Ce que nous faisons",
  designerServiceTitlePlaceholder: "Création de sites web",
  designerServiceDescriptionPlaceholder:
    "Un service clair et sur mesure, pensé pour répondre à vos besoins.",
  designerTeamTitlePlaceholder: "Rencontrez notre équipe",
  designerTeamDescriptionPlaceholder:
    "Une petite équipe expérimentée pour faire avancer votre projet.",
  designerTeamMemberNamePlaceholder: "Marie Dupont",
  designerSocialUrlPlaceholder: "https://instagram.com/votre-entreprise",
  designerTextPlaceholder:
    "Présentez votre histoire, vos valeurs ou ce que vos visiteurs doivent savoir.",
  designerFaqTitlePlaceholder: "Questions fréquentes",
  designerFaqQuestionPlaceholder: "Sous quel délai pouvez-vous commencer ?",
  designerFaqAnswerPlaceholder:
    "La plupart des projets commencent sous deux semaines.",
  designerContactTitlePlaceholder: "Parlons de votre projet",
  designerContactDescriptionPlaceholder:
    "Décrivez-nous votre besoin et nous vous répondrons rapidement.",
  designerHelpFor: "Aide pour",
  designerShowSection: "Afficher ou masquer la section",
  designerColorHelp:
    "Choisissez la couleur principale utilisée pour les boutons, les liens et les éléments mis en avant sur votre site. Sélectionnez une nuance adaptée à votre identité et qui garde le texte facile à lire.",
  designerLogoHelp:
    "Importez l’image principale affichée en haut de votre site. Utilisez une image nette et de bonne qualité qui représente votre activité.",
  designerIntroductionHelp:
    "C’est le premier message que voient vos visiteurs. Indiquez qui vous êtes, ce que vous faites et pourquoi ils devraient poursuivre leur visite.",
  designerExternalLinkHelp:
    "Ajoutez un bouton facultatif qui envoie les visiteurs vers un autre site, par exemple une page de réservation ou une boutique en ligne. Saisissez l’adresse web complète.",
  designerServicesHelp:
    "Activez cette section pour expliquer ce que vous proposez. Ajoutez un titre de section, puis un service et une courte description par ligne.",
  designerPhotosHelp:
    "Activez cette section pour créer une galerie de photos. Ajoutez des images nettes qui montrent votre travail, vos locaux, vos produits ou votre univers.",
  designerTeamHelp:
    "Activez cette section pour présenter les personnes qui font vivre votre activité. Ajoutez un titre, une courte introduction, puis la photo, le nom et les liens sociaux de chaque personne.",
  designerTextHelp:
    "Activez cette section pour ajouter un bloc de texte, par exemple votre histoire, vos valeurs, votre méthode ou des informations pratiques.",
  designerFaqHelp:
    "Activez cette section pour répondre aux questions les plus fréquentes de vos visiteurs. Ajoutez une question claire et sa réponse par ligne.",
  designerContactHelp:
    "Activez cette section pour permettre aux visiteurs de vous envoyer un message. Le titre et la description apparaissent juste au-dessus du formulaire de contact.",
  designerHeroTitleHelp:
    "Le titre principal affiché en haut de votre site. Utilisez généralement le nom de votre activité ou une courte phrase qui explique ce que vous faites.",
  designerHeroDescriptionHelp:
    "Une courte introduction sous le titre principal. Expliquez clairement ce que vous proposez et à qui cela s’adresse en une ou deux phrases.",
  designerButtonTextHelp:
    "Les mots sur lesquels les visiteurs cliquent, par exemple « Réserver un appel ». Utilisez une formule d’action courte.",
  designerButtonUrlHelp:
    "La page qui s’ouvre lorsque les visiteurs cliquent sur le bouton. Saisissez l’adresse complète, par exemple https://exemple.fr.",
  designerServicesTitleHelp:
    "Le titre affiché au-dessus de tous vos services. Utilisez une formule simple qui présente ce que propose votre activité.",
  designerServiceTitleHelp:
    "Le nom d’un service. Faites court pour que les visiteurs puissent parcourir rapidement vos offres.",
  designerServiceDescriptionHelp:
    "Une courte explication du service, de ce que reçoit le client ou de la façon dont ce service l’aide.",
  designerTeamTitleHelp:
    "Le titre affiché au-dessus de votre équipe, par exemple « Rencontrez notre équipe ».",
  designerTeamDescriptionHelp:
    "Une courte présentation de votre équipe, de son expérience ou de votre façon de travailler ensemble.",
  designerTeamMemberNameHelp:
    "Le nom de cette personne. Ajoutez une photo à côté pour que les visiteurs puissent la reconnaître.",
  designerSocialUrlHelp:
    "Un lien vers le profil social de cette personne. Collez l’adresse complète du profil ; l’icône de la plateforme est ajoutée automatiquement.",
  designerTextContentHelp:
    "Rédigez les informations supplémentaires que vous voulez communiquer. Des paragraphes courts et des mots simples sont plus faciles à comprendre.",
  designerFaqTitleHelp:
    "Le titre affiché au-dessus de vos questions fréquentes.",
  designerFaqQuestionHelp:
    "Rédigez la question avec les mots qu’un visiteur utiliserait.",
  designerFaqAnswerHelp:
    "Donnez une réponse directe et utile, en plaçant l’information essentielle en premier.",
  designerContactTitleHelp:
    "Le titre qui invite les visiteurs à vous contacter, par exemple « Parlons de votre projet ».",
  designerContactDescriptionHelp:
    "Une courte note au-dessus du formulaire qui indique aux visiteurs quoi demander ou quand ils peuvent attendre une réponse.",
  Retry: "Réessayer",
  "Signing out...": "Déconnexion...",
  "Checking availability...": "Vérification de la disponibilité...",
  "Loading page content": "Chargement du contenu de la page",
  "Loading...": "Chargement...",
  Loaded: "Chargé",
  "Failed to load SEO settings.": "Impossible de charger les paramètres SEO.",
  "Could not load SEO settings.": "Impossible de charger les paramètres SEO.",
  "Failed to load domains.": "Impossible de charger les domaines.",
  "Could not load site domains.": "Impossible de charger les domaines du site.",
  "Could not load domain status": "Impossible de charger le statut du domaine",
  "Domain verification failed.": "La vérification du domaine a échoué.",
  Domain: "Domaine",
  Services: "Services",
  Photos: "Photos",
  "Failed to load this site.": "Impossible de charger ce site.",
  "Failed to load the editor.": "Impossible de charger l’éditeur.",
  "Could not find this site.": "Impossible de trouver ce site.",
  "Refreshing sites": "Actualisation des sites",
  "Open user menu": "Ouvrir le menu utilisateur",
  "Open main menu": "Ouvrir le menu principal",
  "Image preview": "Aperçu de l’image",
  "Delete image": "Supprimer l’image",
  "Coming soon...": "Bientôt disponible...",
  English: "Anglais",
  French: "Français",
  "Invalid user name or password": "Adresse e-mail ou mot de passe incorrect",
  "user already exists": "Un compte existe déjà pour cette adresse e-mail",
  "Authentication required before upload.":
    "Vous devez être connecté avant d’importer une image.",
  "Upload failed. Could not read server response.":
    "Échec de l’importation. Impossible de lire la réponse du serveur.",
  "Upload failed.": "Échec de l’importation.",
  "Upload failed. Please retry.":
    "Échec de l’importation. Veuillez réessayer.",
  "Processing...": "Traitement...",
  "Uploading...": "Importation...",
  "Processing image...": "Traitement de l’image...",
  "Uploading image...": "Importation de l’image...",
} satisfies { [K in keyof typeof en]: string };
